var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import Router from "./router";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@emotion/react";
import { PerformanceMonitor } from "./hooks/usePerformanceMonitoring";
import { theme } from "./styles/theme";
import "./styles/global.css";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsxs(React.StrictMode, { children: [_jsx(CssBaseline, {}), _jsxs(ThemeProvider, __assign({ theme: theme }, { children: [_jsx(PerformanceMonitor, { reportToConsole: process.env.NODE_ENV === "development", reportToAnalytics: process.env.NODE_ENV === "production" }), _jsx(Router, {})] }))] }));
// register the SW
if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
        navigator.serviceWorker.register("/service-worker.js");
    });
}
